import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { getIsHotelOnly } from 'src/store/view/selectors';
import { useTranslation } from '@lt/localization';
import { similarPackagesGoToHotelAction } from '../../store/actions/similar-packages';
import GoToHotelContainer from '../GoToHotel/GoToHotelContainer';

const SimilarPackageHotelButton = ({
  onClick,
  isHotelOnly,
}: PropsFromRedux) => {
  const { t } = useTranslation();
  return (
    <GoToHotelContainer
      className="similar-packages__hotel-button lt-button-link"
      target="_self"
      primary
      onClick={onClick}
    >
      {t('checkout.similarPackage.button', {
        context: isHotelOnly ? 'hotel' : 'package',
      })}
    </GoToHotelContainer>
  );
};

const mapStateToProps = (state) => ({
  isHotelOnly: getIsHotelOnly(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(similarPackagesGoToHotelAction()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SimilarPackageHotelButton);
